import cache from '@/plugins/cache'

/** 搜索表单草稿 localStorage 键前缀 */
export const SEARCH_DRAFT_PREFIX = 'search_draft_'

/** 未提交表单草稿 localStorage 键前缀 */
export const FORM_DRAFT_PREFIX = 'form_draft_'

/**
 * 清除所有页面搜索/表单草稿（登录时调用，使用期间仍可持续缓存）
 */
export function clearPageDrafts() {
  cache.local.removeByPrefix(SEARCH_DRAFT_PREFIX)
  cache.local.removeByPrefix(FORM_DRAFT_PREFIX)
}
